import { action, observable } from 'mobx'

import Datehelper from '../utils/datehelper';

import Ds from './ds'
import sha1 from 'sha1'

class Invoices {
  @observable ds = new Ds()
  @observable invoice = []
  @observable invoices = []
  @observable invoicesByDate = []
  @observable invoiceDetail = {}
  @observable invoiceHardware = []
  @observable invoiceViewDetails = {
    agreementDetails: '',
    invoiceId: 0,
    paymentId: null,
    quoteType: 'accessory',
    status: 0,
    userFullName: '',
    userEmail: ''
  }
  @observable paidInvoicesBySource = []

  @action resetPaidInvoicesBySource() {
    this.paidInvoicesBySource = [];
  }

  //Invoice View Details
  @action setInvoiceViewDetails(params, callback) {
    this.invoiceViewDetails = {
      agreementDetails: params.agreementDetails,
      paymentId: params.paymentId,
      invoiceId: params.invoiceId,
      quoteType: params.quoteType,
      status: params.status,
      userFullName: params.userFullName,
      userEmail: params.userEmail
    }

    if (callback) {
      return callback()
    }
  }

  //Multiple Invoice Actions
  @action loadInvoices(callback) {
    const query = `{
            quotes(
                hash: "${ localStorage.getItem('userHash')}"
            ) 
            {    
                companyId
                company {
                    defaultContactId
                    name
                    stripeCustomerId
                }
                createdAt
                id
                oneTimeTotal
                paymentId
                payment {
                    amount
                    approvalCode
                    cardNumber
                    cardType
                    createdAt
                    paymentTypeId
                    qbPaymentNumber          
                }
                qbOrderNumber
                quoteType
                serialNumbers
                token
                trackingNumber
            }
        }`

    console.log(query)

    this.ds.query(query, (res) => {
      if (res && res.quotes && res.quotes.length > 0) {
        this.invoices = res.quotes.map((i) => {
          i.approvalCode = null
          i.cardNumber = null
          i.cardType = null
          i.companyDefaultContactId = 0
          i.companyName = null
          i.formattedPaymentDate = null
          i.formattedQuoteDate = null
          i.paymentAmount = 0.00
          i.paymentTypeId = 0
          i.qbPaymentNumber = null
          i.stripeCustomerId = ''

          if (i.closeDate) {
            let dd = new Date(i.closeDate)
            let dateString = ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
            i.formattedCloseDate = dateString
          }

          if (i.company) {
            i.companyName = i.company.name
            i.companyDefaultContactId = i.company.defaultContactId
            i.stripeCustomerId = i.company.stripeCustomerId
          }

          if (i.createdAt) {
            let dd = new Date(i.createdAt)
            let dateString = ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
            i.formattedQuoteDate = dateString
          }

          if (i.payment) {
            i.qbPaymentNumber = i.payment.qbPaymentNumber
            i.paymentTypeId = i.payment.paymentTypeId
            i.paymentAmount = i.payment.amount
            i.approvalCode = i.payment.approvalCode
            i.cardNumber = i.payment.cardNumber
            i.cardType = i.payment.cardType

            let dd = new Date(i.payment.createdAt)
            let dateString = ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
            i.formattedPaymentDate = dateString
          }

          return i
        })

        if (callback) {
          callback(this.invoices)
        }
      } else {
        this.invoices = []
        if (callback) callback(this.invoices)
      }
    })
  }

  @action loadInvoicesByDateRange(dateRange, callback) {
    const query = `{
            quotesByDateRange(
                dateRange: ${ dateRange},
                hash: "${ localStorage.getItem('userHash')}"
            ) 
            {    
                companyId
                company {
                    defaultContactId
                    name
                    assman_compid
                    stripeCustomerId
                }
                createdAt
                id
                oneTimeTotal
                paymentId
                payment {
                    amount
                    approvalCode
                    cardNumber
                    cardType
                    createdAt
                    paymentTypeId
                    qbPaymentNumber          
                }
                qbOrderNumber
                quoteType
                serialNumbers
                token
                trackingNumber
            }
        }`

    console.log(query)

    this.ds.query(query, (res) => {
      if (res && res.quotesByDateRange && res.quotesByDateRange.length > 0) {

        let totalUnpaid = 0;

        this.invoicesByDate = res.quotesByDateRange.map((i) => {
          i.approvalCode = null
          i.cardNumber = null
          i.cardType = null
          i.companyDefaultContactId = 0
          i.companyName = null
          i.formattedPaymentDate = null
          i.formattedQuoteDate = null
          i.paymentAmount = 0.00
          i.paymentTypeId = 0
          i.qbPaymentNumber = null
          i.stripeCustomerId = ''

          if (i.closeDate) {
            let dd = new Date(i.closeDate)
            let dateString = ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
            i.formattedCloseDate = dateString
          }

          if (i.company) {
            i.companyName = i.company.name
            i.company_assman_compid = i.company.assman_id;
            i.companyDefaultContactId = i.company.defaultContactId
            i.stripeCustomerId = i.company.stripeCustomerId
          }

          if (i.createdAt) {
            let dd = new Date(i.createdAt)
            let dateString = ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
            i.formattedQuoteDate = dateString
          }

          if (i.payment) {
            i.qbPaymentNumber = i.payment.qbPaymentNumber
            i.paymentTypeId = i.payment.paymentTypeId
            i.paymentAmount = i.payment.amount
            i.approvalCode = i.payment.approvalCode
            i.cardNumber = i.payment.cardNumber
            i.cardType = i.payment.cardType

            let dd = new Date(i.payment.createdAt)
            let dateString = ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
            i.formattedPaymentDate = dateString
          }

          i.balanceDue = i.oneTimeTotal - i.paymentAmount

          if (i.balanceDue > 0) {
            totalUnpaid = totalUnpaid + i.balanceDue;
          }

          return i
        })

        this.invoicesByDate.totalUnpaid = totalUnpaid;

        if (callback) {
          callback(this.invoicesByDate)
        }
      } else {
        this.invoicesByDate = []
        if (callback) callback(this.invoicesByDate)
      }
    })
  }

  @action loadUnpaidInvoices(callback) {
    const query = `{
            quotesUnpaid(
              hash: "${ localStorage.getItem('userHash')}"
            ) 
            {    
                companyId
                company {
                    defaultContactId
                    assman_compid
                    name
                    stripeCustomerId
                }
                createdAt
                id
                oneTimeTotal
                paymentId
                payment {
                    amount
                    approvalCode
                    cardNumber
                    cardType
                    createdAt
                    paymentTypeId
                    qbPaymentNumber          
                }
                qbOrderNumber
                quoteType
                serialNumbers
                token
                trackingNumber
            }
        }`

    console.log(query)

    this.ds.query(query, (res) => {
      if (res && res.quotesUnpaid && res.quotesUnpaid.length > 0) {

        let totalUnpaid = 0;

        this.invoicesByDate = res.quotesUnpaid.map((i) => {
          i.approvalCode = null
          i.cardNumber = null
          i.cardType = null
          i.companyDefaultContactId = 0
          i.companyName = null
          i.formattedPaymentDate = null
          i.formattedQuoteDate = null
          i.paymentAmount = 0.00
          i.paymentTypeId = 0
          i.qbPaymentNumber = null
          i.stripeCustomerId = ''
          i.balanceDue = 0

          if (i.closeDate) {
            let dd = new Date(i.closeDate)
            let dateString = ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
            i.formattedCloseDate = dateString
          }

          if (i.company) {
            i.companyName = i.company.name
            i.company_assman_compid = i.company.assman_compid;
            i.companyDefaultContactId = i.company.defaultContactId
            i.stripeCustomerId = i.company.stripeCustomerId
          }

          if (i.createdAt) {
            let dd = new Date(i.createdAt)
            let dateString = ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
            i.formattedQuoteDate = dateString
          }

          if (i.payment) {
            i.qbPaymentNumber = i.payment.qbPaymentNumber
            i.paymentTypeId = i.payment.paymentTypeId
            i.paymentAmount = i.payment.amount
            i.approvalCode = i.payment.approvalCode
            i.cardNumber = i.payment.cardNumber
            i.cardType = i.payment.cardType

            let dd = new Date(i.payment.createdAt)
            let dateString = ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
            i.formattedPaymentDate = dateString
          }

          i.balanceDue = i.oneTimeTotal - i.paymentAmount

          if (i.balanceDue > 0) {
            totalUnpaid = totalUnpaid + i.balanceDue;
          }

          return i
        })

        this.invoicesByDate.totalUnpaid = totalUnpaid;

        if (callback) {
          callback(this.invoicesByDate)
        }
      } else {
        this.invoicesByDate = []
        if (callback) callback(this.invoicesByDate)
      }
    })
  }

  @action loadRecentlyPaidInvoices(callback) {
    const query = `{
            quotesPaid(
              hash: "${ localStorage.getItem('userHash')}"
            ) 
            {    
                companyId
                company {
                    defaultContactId
                    assman_compid
                    name
                    stripeCustomerId
                }
                createdAt
                id
                oneTimeTotal
                paymentId
                payment {
                    amount
                    approvalCode
                    cardNumber
                    cardType
                    createdAt
                    paymentTypeId
                    qbPaymentNumber          
                }
                qbOrderNumber
                quoteType
                serialNumbers
                token
                trackingNumber
            }
        }`

    console.log(query)

    this.ds.query(query, (res) => {
      if (res && res.quotesPaid && res.quotesPaid.length > 0) {

        let totalUnpaid = 0;

        this.invoicesByDate = res.quotesPaid.map((i) => {
          i.approvalCode = null
          i.cardNumber = null
          i.cardType = null
          i.companyDefaultContactId = 0
          i.companyName = null
          i.formattedPaymentDate = null
          i.formattedQuoteDate = null
          i.paymentAmount = 0.00
          i.paymentTypeId = 0
          i.qbPaymentNumber = null
          i.stripeCustomerId = ''
          i.balanceDue = 0

          if (i.closeDate) {
            let dd = new Date(i.closeDate)
            let dateString = ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
            i.formattedCloseDate = dateString
          }

          if (i.company) {
            i.companyName = i.company.name
            i.company_assman_compid = i.company.assman_compid;
            i.companyDefaultContactId = i.company.defaultContactId
            i.stripeCustomerId = i.company.stripeCustomerId
          }

          if (i.createdAt) {
            let dd = new Date(i.createdAt)
            let dateString = ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
            i.formattedQuoteDate = dateString
          }

          if (i.payment) {
            i.qbPaymentNumber = i.payment.qbPaymentNumber
            i.paymentTypeId = i.payment.paymentTypeId
            i.paymentAmount = i.payment.amount
            i.approvalCode = i.payment.approvalCode
            i.cardNumber = i.payment.cardNumber
            i.cardType = i.payment.cardType

            let dd = new Date(i.payment.createdAt)
            let dateString = ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
            i.formattedPaymentDate = dateString
          }

          i.balanceDue = i.oneTimeTotal - i.paymentAmount

          if (i.balanceDue > 0) {
            totalUnpaid = totalUnpaid + i.balanceDue;
          }

          return i
        })
        console.log('Store Total unpaid: ', totalUnpaid);
        this.invoicesByDate.totalUnpaid = totalUnpaid;

        if (callback) {
          callback(this.invoicesByDate)
        }
      } else {
        this.invoicesByDate = []
        if (callback) callback(this.invoicesByDate)
      }
    })
  }

  @action getPaidInvoicesBySource(sourceId, startDate, endDate, callback) {
    var convertedStartDate = new Date(Date.parse(startDate))
    var formattedStartDate = Datehelper.dateToTimestamp(convertedStartDate)
    
    var convertedEndDate = new Date(Date.parse(endDate))
    convertedEndDate.setDate(convertedEndDate.getDate()+1)
    var formattedEndDate = Datehelper.dateToTimestamp(convertedEndDate)

    const query = `{
      quotesBySource(
        hash: "${ localStorage.getItem('userHash')}"
        sourceId: ${ sourceId }
        startDate: "${ formattedStartDate }"
        endDate: "${ formattedEndDate }"
      ) 
      {
        id
        amount
        createdAt
        quoteId
        quote {
          id
          company {
            id
            name
            assman_compid
            sourceId
            source {
              id
              name
            }
          }
        }
      }
    }`

    console.log(query)

    this.ds.query(query, (res) => {
      if (res && res.quotesBySource && res.quotesBySource.length > 0) {
        this.paidInvoicesBySource = res.quotesBySource.map((i) => {
          i.companyName = ''
          i.formattedPaymentDate = null

          if (i.quote && i.quote.company && i.quote.company.name) {
            i.companyName = i.quote.company.name
            i.company_assman_compid = i.quote.company.assman_compid;
          }

          if (i.createdAt) {
            let dd = new Date(i.createdAt)
            let dateString = ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
            i.formattedPaymentDate = dateString
          }

          return i
        })

        if (callback) {
          callback(this.paidInvoicesBySource)
        }
      } else {
        this.paidInvoicesBySource = []
        if (callback) callback(this.paidInvoicesBySource)
      }
    })
  }

  //Individual Invoice Actions
  @action loadInvoice(invoiceId, callback) {
    const query = `{
            quotes(
                hash: "${ localStorage.getItem('userHash')}",
                id: ${ invoiceId}
            ) {
                agreementId
                agreement {
                    name
                }
                backendId
                backend {
                    name
                }
                billingAddressId
                billingAddress {
                    name
                    address
                    city
                    state
                    zipCode
                    country
                }
                carrierId
                carrier {
                    name
                }
                closeDate
                closePercentage
                companyId
                company {
                    name
                }
                contractTermId
                contractTerm {
                    terms
                }
                createdAt
                hardwareTotal
                id
                note
                oneTimeTotal
                paymentId
                payment {
                    amount
                    approvalCode
                    cardNumber
                    cardType
                    createdAt
                    paymentTypeId
                    qbPaymentNumber
                }
                paymentIntervalId
                paymentInterval {
                    name
                }
                paymentTermId
                qbItemList
                qbOrderNumber
                qbTaxRateList
                qbTermList
                quoteType
                serialNumbers
                serviceId
                shippingAddressId
                shippingAddress {
                    name
                    address
                    city
                    state
                    zipCode
                    country
                }
                shippingCost
                shippingTypeId
                shippingType {
                    name
                }
                taxRateId
                taxTotal
                trackingNumber
                userId
                user {
                    firstName
                    lastName
                    email
                }
            }
        }`

    console.log(query)

    this.ds.query(query, (res) => {
      if (res && res.quotes && res.quotes.length > 0) {
        this.invoice = res.quotes.map((i) => {
          i.agreementName = ''
          i.backendName = ''
          i.billingAddressName = ''
          i.billingAddressAddress = ''
          i.billingAddressCity = ''
          i.billingAddressState = ''
          i.billingAddressProvince = ''
          i.billingAddressZipCode = ''
          i.billingAddressCountry = ''
          i.carrierName = ''
          i.companyName = ''
          i.contractTermName = ''
          i.hardwareTotal = i.hardwareTotal.toFixed(2)
          i.oneTimeTotal = i.oneTimeTotal.toFixed(2)
          i.paymentIntervalName = ''
          i.paymentTermName = ''
          i.shippingAddressName = ''
          i.shippingAddressAddress = ''
          i.shippingAddressCity = ''
          i.shippingAddressState = ''
          i.shippingAddressZipCode = ''
          i.shippingCost = i.shippingCost.toFixed(2)
          i.shippingTypeName = ''
          i.taxRate = 0
          i.taxTotal = i.taxTotal.toFixed(2)
          i.userFirstName = ''
          i.userLastName = ''
          i.userFullName = ''
          i.userEmail = ''

          if (i.agreement) {
            i.agreementName = i.agreement.name
          }

          if (i.backend) {
            i.backendName = i.backend.name
          }

          if (i.billingAddress) {
            i.billingAddressName = i.billingAddress.name
            i.billingAddressAddress = i.billingAddress.address
            i.billingAddressCity = i.billingAddress.city
            i.billingAddressState = i.billingAddress.state
            i.billingAddressZipCode = i.billingAddress.zipCode
            i.billingAddressCountry = i.billingAddress.country
          }

          if (i.carrier) {
            i.carrierName = i.carrier.name
          }

          if (i.company) {
            i.companyName = i.company.name
          }

          if (i.contractTerm) {
            i.contractTermName = i.contractTerm.terms
          }

          if (i.createdAt) {
            let dd = new Date(i.createdAt)
            let dateString = ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
            i.formattedQuoteDate = dateString
          }

          if (i.paymentInterval) {
            i.paymentIntervalName = i.paymentInterval.name
          }

          if (i.qbItemList) {
            i.qbItemList.map((qb) => {
              if (qb.id == i.serviceId) {
                i.serviceName = qb.name
                i.serviceDescription = qb.description
              }
            })
          }

          if (i.qbTaxRateList) {
            i.qbTaxRateList.map((qb) => {
              if (qb.id == i.taxRateId) {
                i.taxRateName = qb.name
                i.taxRate = qb.taxRate
              }
            })
          }

          if (i.qbTermList) {
            i.qbTermList.map((qb) => {
              if (qb.id == i.paymentTermId) {
                i.paymentTermName = qb.name
              }
            })
          }

          if (i.shippingAddress) {
            i.shippingAddressName = i.shippingAddress.name
            i.shippingAddressAddress = i.shippingAddress.address
            i.shippingAddressCity = i.shippingAddress.city
            i.shippingAddressState = i.shippingAddress.state
            i.shippingAddressZipCode = i.shippingAddress.zipCode
            i.shippingAddressCountry = i.shippingAddress.country
          }

          if (i.shippingType) {
            i.shippingTypeName = i.shippingType.name
          }

          if (i.user) {
            i.userFirstName = i.user.firstName
            i.userLastName = i.user.lastName
            i.userFullName = i.user.firstName + ' ' + i.user.lastName
            i.userEmail = i.user.email

          }

          return i
        })[0]
        console.log('invoice: ', this.invoice)
        if (callback) {
          callback(this.invoice)
        }
      } else {
        if (callback) callback(null)
      }
    })
  }

  @action loadInvoiceNoQB(invoiceId, qbItemList, qbTermsList, qbTaxRatesList, callback) {
    const query = `{
        quotes(
            hash: "${ localStorage.getItem('userHash')}",
            id: ${ invoiceId}
        ) {
            agreementId
            agreement {
                name
            }
            backendId
            backend {
                name
            }
            billingAddressId
            billingAddress {
                name
                address
                city
                state
                zipCode
            }
            carrierId
            carrier {
                name
            }
            closeDate
            closePercentage
            companyId
            company {
                name
            }
            contractTermId
            contractTerm {
                terms
            }
            createdAt
            hardwareTotal
            id
            note
            oneTimeTotal
            paymentId
            payment {
                amount
                approvalCode
                cardNumber
                cardType
                createdAt
                paymentTypeId
                qbPaymentNumber
            }
            paymentIntervalId
            paymentInterval {
                name
            }
            paymentTermId
            qbOrderNumber
            quoteType
            serialNumbers
            serviceId
            shippingAddressId
            shippingAddress {
                name
                address
                city
                state
                zipCode
            }
            shippingCost
            shippingTypeId
            shippingType {
                name
            }
            taxRateId
            taxTotal
            trackingNumber
            userId
            user {
                firstName
                lastName
                email
            }
        }
    }`

    console.log(query)

    this.ds.query(query, (res) => {
      if (res && res.quotes && res.quotes.length > 0) {
        this.invoice = res.quotes.map((i) => {
          i.agreementName = ''
          i.backendName = ''
          i.billingAddressName = ''
          i.billingAddressAddress = ''
          i.billingAddressCity = ''
          i.billingAddressState = ''
          i.billingAddressZipCode = ''
          i.carrierName = ''
          i.companyName = ''
          i.contractTermName = ''
          i.hardwareTotal = i.hardwareTotal.toFixed(2)
          i.oneTimeTotal = i.oneTimeTotal.toFixed(2)
          i.paymentIntervalName = ''
          i.paymentTermName = ''
          i.shippingAddressName = ''
          i.shippingAddressAddress = ''
          i.shippingAddressCity = ''
          i.shippingAddressState = ''
          i.shippingAddressZipCode = ''
          i.shippingCost = i.shippingCost.toFixed(2)
          i.shippingTypeName = ''
          i.taxRate = 0
          i.taxTotal = i.taxTotal.toFixed(2)
          i.userFirstName = ''
          i.userLastName = ''
          i.userFullName = ''
          i.userEmail = ''

          if (i.agreement) {
            i.agreementName = i.agreement.name
          }

          if (i.backend) {
            i.backendName = i.backend.name
          }

          if (i.billingAddress) {
            i.billingAddressName = i.billingAddress.name
            i.billingAddressAddress = i.billingAddress.address
            i.billingAddressCity = i.billingAddress.city
            i.billingAddressState = i.billingAddress.state
            i.billingAddressZipCode = i.billingAddress.zipCode
          }

          if (i.carrier) {
            i.carrierName = i.carrier.name
          }

          if (i.company) {
            i.companyName = i.company.name
          }

          if (i.contractTerm) {
            i.contractTermName = i.contractTerm.terms
          }

          if (i.createdAt) {
            let dd = new Date(i.createdAt)
            let dateString = ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
            i.formattedQuoteDate = dateString
          }

          if (i.paymentInterval) {
            i.paymentIntervalName = i.paymentInterval.name
          }

          if (qbItemList) {
            qbItemList.map((qb) => {
              if (qb.id == i.serviceId) {
                i.serviceName = qb.name
                i.serviceDescription = qb.description
              }
            })
          }

          if (qbTermsList) {
            qbTermsList.map((qb) => {
              if (qb.id == i.paymentTermId) {
                i.paymentTermName = qb.name
              }
            })
          }

          if (qbTaxRatesList) {
            qbTaxRatesList.map((qb) => {
              if (qb.id == i.taxRateId) {
                i.taxRateName = qb.name
                i.taxRate = qb.taxRate
              }
            })
          }

          if (i.shippingAddress) {
            i.shippingAddressName = i.shippingAddress.name
            i.shippingAddressAddress = i.shippingAddress.address
            i.shippingAddressCity = i.shippingAddress.city
            i.shippingAddressState = i.shippingAddress.state
            i.shippingAddressZipCode = i.shippingAddress.zipCode
          }

          if (i.shippingType) {
            i.shippingTypeName = i.shippingType.name
          }

          if (i.user) {
            i.userFirstName = i.user.firstName
            i.userLastName = i.user.lastName
            i.userFullName = i.user.firstName + ' ' + i.user.lastName
            i.userEmail = i.user.email
          }

          return i
        })[0]
        if (callback) {
          callback(this.invoice)
        }
      } else {
        if (callback) callback(null)
      }
    })
  }

  @action loadInvoiceByToken(token, emailStatus, callback) {
    const query = `{
          quoteToken(
            emailStatus: ${ emailStatus},
            token: "${ token}"
          ) {
            agreementId
            agreement {
              name
              agreement
            }
            backendId
            backend {
              name
            }
            billingAddressId
            billingAddress {
              name
              address
              city
              state
              zipCode
              country
            }
            carrierId
            carrier {
              name
            }
            closeDate
            closePercentage
            companyId
            company {
              name
              stripeCustomerId
              defaultContactId
              defaultContact{
                email
              }
            }
            contractTermId
            contractTerm {
              terms
            }
            createdAt
            hardwareTotal
            hardware {
              id
              sortId
              quoteId
              hardwareId
              description
              quantity
              cost
              serviceCost
              taxExempt
            }
            id
            note
            oneTimeTotal
            organizationId
            paymentId
            paymentIntervalId
            paymentInterval {
              name
            }
            paymentTermId
            qbItemList
            qbOrderNumber
            qbTaxRateList
            qbTermList
            quoteType
            serialNumbers
            shippingAddressId
            shippingAddress {
              name
              address
              city
              state
              zipCode
              country
            }
            shippingCost
            shippingTypeId
            shippingType {
              name
            }
            status
            taxRateId
            taxTotal
            token
            userId
            user {
              firstName
              lastName
              email
            }
          }
        }`

    console.log(query)

    this.ds.query(query, (res) => {
      if (res && res.quoteToken && res.quoteToken.length > 0) {

        this.invoiceDetail = res.quoteToken.map((i) => {
          i.agreementName = ''
          i.agreementDetail = ''
          i.backendName = ''
          i.billingAddressName = ''
          i.billingAddressAddress = ''
          i.billingAddressCity = ''
          i.billingAddressState = ''
          i.billingAddressZipCode = ''
          i.billingAddressCountry = '',
            i.carrierName = ''
          i.companyName = ''
          i.contractTermName = ''
          i.defaultContactId = 0
          i.formattedQuoteDate = ''
          i.hardwareTotal = i.hardwareTotal.toFixed(2)
          i.oneTimeTotal = i.oneTimeTotal.toFixed(2)
          i.paymentIntervalName = ''
          i.paymentTermName = ''
          i.quoteHardware = []
          i.shippingCost = i.shippingCost.toFixed(2)
          i.shippingAddressName = ''
          i.shippingAddressAddress = ''
          i.shippingAddressCity = ''
          i.shippingAddressState = ''
          i.shippingAddressZipCode = ''
          i.shippingAddressCountry = '',
            i.shippingTypeName = ''
          i.stripeCustomerId = ''
          i.taxTotal = i.taxTotal.toFixed(2)
          i.taxRate = 0
          i.userFirstName = ''
          i.userLastName = ''
          i.userFullName = ''
          i.userEmail = ''

          if (i.agreement) {
            i.agreementName = i.agreement.name
            i.agreementDetails = i.agreement.agreement
          }

          if (i.backend) {
            i.backendName = i.backend.name
          }

          if (i.billingAddress) {
            i.billingAddressName = i.billingAddress.name
            i.billingAddressAddress = i.billingAddress.address
            i.billingAddressCity = i.billingAddress.city
            i.billingAddressState = i.billingAddress.state
            i.billingAddressZipCode = i.billingAddress.zipCode
            i.billingAddressCountry = i.billingAddress.country
          }

          if (i.carrier) {
            i.carrierName = i.carrier.name
          }

          if (i.company) {
            i.companyName = i.company.name
            i.stripeCustomerId = i.company.stripeCustomerId
            i.defaultContactId = i.company.defaultContactId

            if (i.company.defaultContact) {
              i.defaultContactEmail = i.company.defaultContact.email
            }
          }

          if (i.contractTerm) {
            i.contractTermName = i.contractTerm.terms
          }

          if (i.createdAt) {
            let dd = new Date(i.createdAt)
            let dateString = ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
            i.formattedQuoteDate = dateString
          }

          if (i.paymentInterval) {
            i.paymentIntervalName = i.paymentInterval.name
          }

          if (i.qbItemList) {
            i.quoteHardware = i.hardware.map((qh) => {
              qh.name = ''
              i.qbItemList.map((qb) => {
                if (qb.Id == qh.hardwareId) {
                  qh.hardwareName = qb.Name

                  //Check to see if a hardware description exists in the DB.  If not, use the QB description if available.
                  if (qh.description != null) {
                    qh.hardwareDescription = qh.description
                  } else {
                    qh.hardwareDescription = qb.Description
                  }
                }
              })

              return qh
            })
          }

          if (i.qbTaxRateList) {
            i.qbTaxRateList.map((qb) => {
              if (qb.Id == i.taxRateId) {
                i.taxRateName = qb.Name
                i.taxRate = qb.TaxRate
              }
            })
          }

          if (i.qbTermList) {
            i.qbTermList.map((qb) => {
              if (qb.Id == i.paymentTermId) {
                i.paymentTermName = qb.Name
              }
            })
          }

          if (i.shippingAddress) {
            i.shippingAddressName = i.shippingAddress.name
            i.shippingAddressAddress = i.shippingAddress.address
            i.shippingAddressCity = i.shippingAddress.city
            i.shippingAddressState = i.shippingAddress.state
            i.shippingAddressZipCode = i.shippingAddress.zipCode
            i.shippingAddressCountry = i.shippingAddress.country
          }

          if (i.shippingType) {
            i.shippingTypeName = i.shippingType.name
          }

          if (i.user) {
            i.userFirstName = i.user.firstName
            i.userLastName = i.user.lastName
            i.userFullName = i.user.firstName + ' ' + i.user.lastName
            i.userEmail = i.user.email
          }

          return i
        })[0]

        if (callback) {

          callback(this.invoiceDetail)
        }
      } else {
        if (callback) callback(null)
      }
    })
  }

  @action saveInvoice(data, callback) {
    const query = `mutation {
      saveQuote(
        token: "${ sha1(data.companyId + '_' + localStorage.getItem('userOrganizationId') + '_' + (new Date().getTime()))}"
        accessoriesTotal: ${ data.accessoriesTotal},
        activation: ${ data.activation},
        agreementId: ${ data.agreementId},
        backendId: ${ data.backendId},
        billingAddressId: ${ data.billingAddressId},
        carrierId: ${ data.carrierId},
        closeDate: "${ data.closeDate}",
        closePercentage: ${ data.closePercentage},
        companyId: ${ data.companyId},
        contractTermId: ${ data.contractTermId},
        paymentTermId: ${ data.paymentTermId},
        demo: 0,
        featureTotal: ${ data.featureTotal},
        hardwareTotal: ${ data.hardwareTotal},
        hash: "${ localStorage.getItem('userHash')}",
        lease: 0,
        monthlyTotal: ${ data.monthlyTotal},
        note: "${ data.note}",
        oneTimeTotal: ${ data.oneTimeTotal},
        organizationId: ${ localStorage.getItem('userOrganizationId')},
        paymentIntervalId: ${ data.paymentIntervalId},
        quoteTypeId: 0,
        serviceId: ${ data.serviceId},
        serviceTotal: ${ data.serviceTotal},
        shippingAddressId: ${ data.shippingAddressId},
        shippingCost: ${ data.shippingCost},
        shippingTypeId: ${ data.shippingTypeId},
        status: ${ data.status},
        taxTotal: ${ data.taxTotal},
        taxRateId: ${ data.taxRateId},
        userId: ${ localStorage.getItem('userId')},
        quoteType: "${ data.quoteType}"
      ) {
        id,
        token
      }
    }`

    console.log(query)

    this.ds.query(query, (res) => {
      if (callback) {
        callback(res.saveQuote)
      }
    })
  }

  @action updateInvoice(data, callback) {
    const query = `mutation {
          updateQuote(
            id: ${ data.invoiceId},
            accessoriesTotal: ${ data.accessoriesTotal},
            activation: ${ data.activation},
            agreementId: ${ data.agreementId},
            backendId: ${ data.backendId},
            billingAddressId: ${ data.billingAddressId},
            carrierId: ${ data.carrierId},
            closeDate: "${ data.closeDate}",
            closePercentage: ${ data.closePercentage},
            companyId: ${ data.companyId},
            contractTermId: ${ data.contractTermId},
            paymentTermId: ${ data.paymentTermId},
            demo: 0,
            featureTotal: ${ data.featureTotal},
            hardwareTotal: ${ data.hardwareTotal},
            hash: "${ localStorage.getItem('userHash')}",
            lease: 0,
            monthlyTotal: 0,
            note: "${ data.note}",
            oneTimeTotal: ${ data.oneTimeTotal},
            organizationId: ${ localStorage.getItem('userOrganizationId')},
            paymentIntervalId: ${ data.paymentIntervalId},
            quoteTypeId: 0,
            serviceId: ${ data.serviceId},
            serviceTotal: 0,
            shippingAddressId: ${ data.shippingAddressId},
            shippingCost: ${ data.shippingCost},
            shippingTypeId: ${ data.shippingTypeId},
            status: ${ data.status},
            taxTotal: ${ data.taxTotal},
            taxRateId: ${ data.taxRateId},
            userId: ${ localStorage.getItem('userId')},
            quoteType: "${ data.quoteType}"
          ) {
            id
          }
        }`

    console.log(query)

    this.ds.query(query, (res) => {
      if (callback) {
        callback(res.updateQuote)
      }
    })
  }

  @action deleteInvoice(id, callback) {
    let query = `mutation {
          deleteQuote(
            hash: "${ localStorage.getItem('userHash')}",
            id: ${ id}
          ) {
            id
          }
        }`

    this.ds.query(query, () => {
      if (callback) {
        callback()
      }
    })
  }

  @action saveInvoiceSignature(data, callback) {
    const query = `mutation {
      saveQuoteSignature(
        id: ${ data.invoiceId},
        signature: "${ data.signature}"
      ) {
        id
      }
    }`

    console.log(query)

    this.ds.query(query, (res) => {
      if (callback) {
        callback(res)
      }
    })
  }

  // Email Invoices

  @action emailInvoice(params, callback) {
    const query = `mutation {
        emailQuote(
            contactId: ${ params.contactId},
            hash: "${ localStorage.getItem('userHash')}",
            token: "${ params.token}"
        ) {
            id
        }
        }`

    console.log(query)

    this.ds.query(query, (res) => {
      if (callback) {
        callback(res)
      }
    })
  }

  //Hardware Calls

  @action loadInvoiceHardware(invoiceId, qbItemList, callback) {
    const query = `{
          quoteHardware(
            hash: "${ localStorage.getItem('userHash')}",
            quoteId: ${ invoiceId}
          ) {
            cost
            description
            hardwareId
            id
            quantity
            serviceCost
            sortId
            taxExempt
          }
        }`

    console.log(query)

    this.ds.query(query, (res) => {
      if (res && res.quoteHardware && res.quoteHardware.length > 0) {
        this.invoiceHardware = res.quoteHardware.map((ih) => {

          ih.hardwareDescription = ''
          ih.hardwareName = ''

          qbItemList.map((qb) => {
            if (qb.Id == ih.hardwareId) {
              ih.hardwareName = qb.Name

              //Check to see if a hardware description exists in the DB.  If not, use the QB description if available.
              if (ih.description != null) {
                ih.hardwareDescription = ih.description
              } else {
                ih.hardwareDescription = qb.Description
              }
            }
          })
          return ih
        })
      } else {
        this.invoiceHardware = []
      }

      if (callback) {
        callback(res.quoteHardware)
      }
    })
  }

  @action addInvoiceHardware(row, callback) {
    const query = `mutation {
      addQuoteHardware(
        quoteId: ${ row.invoiceId},
        sortId: ${ row.sortId},
        hardwareId: ${ row.hardwareId},
        description: "${ row.description}",
        quantity: ${ row.quantity},
        cost: ${ row.cost},
        serviceCost: ${ row.serviceCost},
        taxExempt: ${ row.taxExempt},
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
      }
    }`
    console.log(query)
    this.ds.query(query, (res) => {
      if (callback != null) {
        callback(res)
      }
    })
  }

  @action deleteInvoiceHardware(row, callback) {
    let query = `mutation {
      deleteQuoteHardware(
        id: ${ row.id},
        hash: "${ row.hash}"
      ) {
        id
      }
    }`

    this.ds.query(query, (res) => {
      if (callback != null) {
        callback(res)
      }
    })
  }

  //Serial Numbers

  @action loadSerialNumbers(quoteId, callback) {
    const query = `{
          quotes(
            hash: "${ localStorage.getItem('userHash')}",
            id: ${ quoteId}
          ) {
              serialNumbers
          }
        }`

    console.log(query)

    this.ds.query(query, (data) => {
      if (callback) {
        if (data.quotes && data.quotes.length > 0 && data.quotes[0].serialNumbers) {
          callback(data.quotes[0].serialNumbers)
        } else {
          callback('');
        }
      }
    })
  }

  @action saveSerialNumbers(id, serialNumbers, callback) {
    let query = `mutation {
          addSerialNumbers(
            hash: "${ localStorage.getItem('userHash')}",
            id: ${ id},
            serialNumbers: "${ serialNumbers.trim().match(/([A-Z]*|[0-9]*)\w+/g).join(', ')}",
          ) {
            id
          }
        }`

    console.log(query)

    this.ds.query(query, (data) => {
      if (callback) {
        callback(data)
      }
    })
  }

  //Tracking Numbers

  @action loadTrackingNumber(quoteId, callback) {
    const query = `{
          quotes(
            hash: "${ localStorage.getItem('userHash')}",
            id: ${ quoteId}
          ) {
              trackingNumber
          }
        }`

    console.log(query)

    this.ds.query(query, (data) => {
      if (callback) {
        if (data.quotes && data.quotes.length > 0 && data.quotes[0].trackingNumber) {
          callback(data.quotes[0].trackingNumber)
        } else {
          callback('');
        }
      }
    })
  }

  @action saveTrackingNumber(id, trackingNumber, callback) {
    let query = `mutation {
          addTrackingNumber(
            hash: "${ localStorage.getItem('userHash')}",
            id: ${ id},
            trackingNumber: "${ trackingNumber}"
          ) {
            id
          }
        }`

    console.log(query)

    this.ds.query(query, (data) => {
      if (callback) {
        callback(data)
      }
    })
  }
}

export default new Invoices()



// WEBPACK FOOTER //
// ./src/stores/invoices.js